import { useI18n } from '@packages/shared';

/**
 * Hook to get the final language and the cache key for the footer CMS.
 *
 * @returns {Object} An object containing the final language and the footer CMS cache key.
 * @property {string} finalLanguage - The final language, which is either the current language, the default language, or 'de' if both are undefined.
 * @property {string} footerCmsCacheKey - The cache key for the footer CMS, which is a string that starts with 'footer-' followed by the final language.
 */
export const useFooterDetails = () => {
  const { language, defaultLanguage } = useI18n();
  const finalLanguage = language || defaultLanguage;
  const footerCmsCacheKey = `footer-${finalLanguage}`;

  return { finalLanguage, footerCmsCacheKey };
};
